export enum PopupType {
  DELETE_TEMPLATE = 'delete-template',
  MAP_FIELDS = 'map-fields',
  UPDATE_TEMPLATE = 'update-template',
}
